<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div id="nav_left">    
    <div ref="navMenuLeft" class="nav_menu-left">
      <ul v-bind:class="{'wy-menu': true, isCollapse: isCollapse }">
        <li v-for="(item) in navMenu.items" :key="item.path" v-bind:class="{'wy-menu-item': true, active: item.isActive, 'align-bottom': item.alignBottom, 'hideItem': item.productCode && !isProductAllow(item), isExtend: item.isExtend}" :style="`bottom: ${item.alignBottomIndex*56}px`" :data-testid="item.dataTestId?item.dataTestId:undefined">
            <el-button v-if="item.subItems && !item.disableExpandable" v-bind:class="{'angle-down':!item.isExtend, 'angle-up':item.isExtend }" class="angle-down" @click="toggleExpend(item)"></el-button>
            <el-button v-else-if="item.label=='Configuration'&&(!item.permission || isRoleAllow(item.permission))" class="arrow-right" @click="handleMenuClick(item)"></el-button>
            
            <div v-if="(!item.permission || isRoleAllow(item.permission) && item.label!='Configuration')" @click="handleMenuClick(item)">
              <i :class="{'wy-menu-icon': item.icon, 'el-icon-': item.icon}" v-bind:style="imageStyle(item)"></i><!-- //NOSONAR -->
              <span class="wy-menu-title">{{item.label}}</span>              
            </div>
            <div v-else-if="(!item.permission || isRoleAllow(item.permission))" @click="handleMenuClick(item)">
              <span class="wy-menu-title">{{item.label}}</span>              
            </div>

            <ul class="wy-submenu" v-if="!isCollapse && (!item.permission || isRoleAllow(item.permission))">
              <li v-for="subItem in getSubItems(item)" :key="subItem.path" v-bind:class="{ 'wy-submenu-item': true, active: subItem.isActive }" :data-testid="subItem.dataTestId?subItem.dataTestId:undefined" @click="handleMenuClick(subItem)">
                <i class="wy-menu-icon el-icon-" v-bind:style="imageStyle(subItem)"></i><!-- //NOSONAR -->
                <span class="wy-submenu-title">{{subItem.label}}</span>
              </li>
            </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'NavLeft',

  data() {
    return {
      isCollapse: false
    }
  },

  watch:{
    $route (to){
      this.activeMenuItem(to);
    },

    noDataRoutePath() {
      this.activeMenuItem(this.$route);
    }
  },

  computed: {
    ...mapGetters(['branding', 'companyConfig', 'currentNavMenu', 'isProductAllow', 'isRoleAllow', 'noDataRoutePath', 'dataModel', 'authUser']),

    navMenu() {
      return (this.currentNavMenu) ? this.currentNavMenu : {}
    }
  },

  methods: {
    ...mapMutations(['updateSite']),

    getSubItems(item) {
      return item.subItems ? item.subItems.filter(subItem => (!subItem.isHidden && this.isRoleAllow(subItem.aclCodes))) : [];
    },

    toggleNavHandler(item) {
      if(item.isActive) this.isCollapse = !this.isCollapse;
    },

    async handleMenuClick(item) {
      if(item.modalComponent) {
        this.$root.$emit(`fire-app-modal-events`, item.modalComponent);
      }
      else {
        if(item.iframeUrl) {
          let pageFrameRouter = this.$router.options.routes.find(el => el.name=="pageFrame");
          if(pageFrameRouter && pageFrameRouter.meta) {
            pageFrameRouter.meta.iframeUrl = item.iframeUrl
          }
        }
        this.toggleExpend(item);
        this.$router.push({path: item.path});
      }
    },

    imageStyle(item) {
      const brand = this.branding;
      if(brand) {
        if(item.isActive) {
          return {
            'background-image': item.icon ? `url(${this.$root.locationPath}/${brand}/images/menu/${item.icon}_selected_${brand}.svg)` : "none",
            'background-size': `${item.iconWidth ? item.iconWidth : 15}px ${item.iconHeight ? item.iconHeight : 15}px`
          }
        }
        else {
          return {
            'background-image': item.icon ? `url(${this.$root.locationPath}/${brand}/images/menu/${item.icon}_selected_${brand}.svg)` : "none",
            'background-size': `${item.iconWidth ? item.iconWidth : 15}px ${item.iconHeight ? item.iconHeight : 15}px`
          }
        }
      }
      else {
        if(item.isActive) {
          return {
            'background-image': item.icon ? `url(${this.$root.locationPath}/oc/images/menu/${item.icon}_selected_${brand}.svg)` : "none",
            'background-size': `${item.iconWidth ? item.iconWidth : 15}px ${item.iconHeight ? item.iconHeight : 15}px`
          }
        }
        else {
          return {
            'background-image': item.icon ? `url(${this.$root.locationPath}/oc/images/menu/${item.icon}_selected_${brand}.svg)` : "none",
            'background-size': `${item.iconWidth ? item.iconWidth : 15}px ${item.iconHeight ? item.iconHeight : 15}px`
          }
        }
      }
      
    },

    activeMenuItem(route) {
      let path = route.path;
      if(this.navMenu && this.navMenu.items) {
        this.navMenu.items.forEach(item => {
          item.isActive = (item.path == path || (`${item.path}/` == path) || (item.childPaths && item.childPaths.includes(path)) || item.path == route.meta.parentPath || item.path == this.noDataRoutePath);
          
          if(item.subItems) {
            item.subItems.forEach(subItem => {
              if(subItem.path == path || subItem.path == this.noDataRoutePath) {
                item.isActive = true;
              }
              subItem.isActive = (subItem.path == path || subItem.path == this.noDataRoutePath);
            })
          }
        });
      }
    },

    toggleExpend(item) {
      item.isExtend = !item.isExtend;
      this.updateSite({navMenu: this.currentNavMenu});
    }
  },

  mounted() {
    if(this.$route.path && this.$route.path != '') {
      this.activeMenuItem(this.$route);
    }
  }
}
</script>

<style lang="scss">
.wy-container-nav {
  width: 300px !important;
  border-right: 1px solid #CAD2DA;
}
.wy-container-main {
  padding: 40px 20px 0px 20px !important;
}
#nav_left {
  height: 100%;
  width: 100%;
  display: inline-block;
  // padding-top: 5px;
  background-color: var(--site-nav-left-background-color);

  .nav_menu-left {
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    float: left;
    // background-color: #EDECEC;

    .wy-menu-icon {
      padding-right: 12px !important;
      width: 15px !important;
      height: 56px !important;
      background-repeat: no-repeat;
      background-size: 15px 15px;
      vertical-align: middle;
      background-position-y: center;
    }

    .wy-menu.isCollapse {
      width: 55px;
      .wy-menu-title, .wy-submenu-title {
        display: none;
      }

      .wy-submenu-item {
        padding-left: 20px !important;
      }
      .wy-menu-item > div {
        padding: 0px 0px 0px 20px;
      }
    }
    .wy-menu {
      width: 100%;
      height: calc(100vh - 82px);
      position: relative;
      margin: 0;
      padding-left: 0;
      transition: all .3s linear;
      background-color: var(--site-nav-left-background-color);
      
      .wy-submenu .wy-submenu-item {
        padding-left: 28px !important;
      }
      .wy-menu-item.align-bottom {
        bottom: 5px;
        position: absolute;
        width: 100%;
        border-top: 3px solid #214586;
        border-bottom: 0px solid #214586 !important;
        background-color: #edecec;
      }

      .wy-menu-item.align-bottom:hover {
        background-color: #ECEDEF;
      }

      .wy-menu-item.hideItem {
        display: none;
      }
      .wy-menu-item.isExtend {
        height: auto !important;
        .wy-submenu {
          display: block !important;
        }
      }
      .wy-menu-item:last-child {
        height: 57px;
        border-bottom: 0;
      }
      .wy-menu-item {
        background-color: var(--site-nav-left-background-color);
        padding-bottom: 6px;
        border-bottom: 1px solid #C9D3DA;
        height: 56px;
        padding-top: 6px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        // background-color: #C9D3DA;
        // // padding-top: 0.5px;
        // padding-bottom: 1px;
        // height: 56px;
        .wy-submenu {
          display: none;
        }
        .angle-down {
          background-image: url("../assets/images/angle_down.svg");
          background-repeat: no-repeat;
          background-color: transparent;
          border: 0;
          padding: 0;
          top: 25px;
          position: relative;
          height: 20px;
          width: 10px;
          float: right;
          margin-right: 27px;
        }
        .angle-up {
          background-image: url("../assets/images/angle_up.svg");
          background-repeat: no-repeat;
          background-color: transparent;
          border: 0;
          padding: 0;
          top: 25px;
          position: relative;
          height: 20px;
          width: 17px;
          float: right;
          margin-right: 21px;
        }

        .arrow-right {
          background-image: url("../assets/images/icon_arrow_right.svg");
          background-repeat: no-repeat;
          background-color: transparent;
          border: 0;
          padding: 0;
          top: 23px;
          position: relative;
          height: 20px;
          width: 16px;
          float: right;
          margin-right: 25px;
        }

        > div {
          padding: 0px 0px 0px 28px;
          cursor: pointer;
          // border-bottom: 2px solid #214586!important;
          // background-color: #FBFDFF;
          background-color: var(--site-nav-left-background-color);
          color: var(--site-font-secondary-color);
          height: 56px;

          .wy-menu-title {
            font-size: 14px !important;
            box-sizing: border-box;
            height: 56px;
            line-height: 56px;
            position: relative;
            white-space: nowrap;
            list-style: none;            
            vertical-align: middle;
            // color: #C9D8F3;
            color: var(--site-nav-left-primary-font-color);
            font-weight: 700; 
          }
        }
      }

      .wy-menu-item.active {
        .wy-menu-title {
          // color: #C9D8F3;
          color: var(--site-nav-left-primary-font-color);
          font-weight: 700; 
        }

        .wy-submenu {
          visibility: visible;
          max-height: 500px;
          transition: max-height 0.5s ease-in;
        }

        > div {  // Adjusts the distance between first child and itself
          height: 56px;
        }
      }

      .wy-menu-item:hover {
        // background-color: #ECEDEF;
        // background-color: #C9D3DA;
      }

      .wy-submenu {
        //visibility: hidden;  // Uncomment to enable menu item collapse (also uncomment menu-right)
        //max-height: 0;       // Uncomment to enable menu item collapse (also uncomment menu-right)
        background-color: #edecec;
        //border-right: solid 1px #e6e6e6;
        list-style: none;
        position: relative;
        margin: 0;
        padding-left: 0;
        transition: max-height 0.5s ease-out;
        overflow: hidden;

        .wy-submenu-item {
          background-color: var(--site-nav-left-background-color);
          font-size: 14px;
          font-weight: 600;
          color: var(--site-font-secondary-color);
          cursor: pointer;
          box-sizing: border-box;
          position: relative;
          white-space: nowrap;
          list-style: none;
          display: list-item;
          height: 51px;
          line-height: 51px;
          padding: 0;
          min-width: 200px;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          -o-user-select: none;
          user-select: none;
          // border-bottom: 2px solid #214586!important;  

          .wy-submenu-title {
            background-color: #FBFDFF;
            font-size: 14px !important;
            font-weight: 500;
            color: var(--site-font-secondary-color);
            box-sizing: border-box;
            height: 56px;
            line-height: 56px;
            position: relative;
            white-space: nowrap;
            list-style: none;
            cursor: pointer;
            vertical-align: middle;
            display: relative;
            bottom: 3px;
          }

          .wy-menu-icon {
            height: 51px !important;
          }
        }
      }

      .wy-submenu-item.active {
        background-color: var(--site-nav-left-item-active-background-color);
        .wy-submenu-title {
          font-weight: 500;
          color: var(--site-font-secondary-color);
          background-color: var(--site-nav-left-item-active-background-color);
        }
      }

      .wy-submenu-item:hover {
        background-color: var(--site-nav-left-item-hover-background-color);
        .wy-submenu-title {
          background-color: var(--site-nav-left-item-hover-background-color);
        }
      }
    }
  }

  .nav_menu-right {
    display: none;
    width: 20px;
    height: 100%;
    float: right;
    background: #E4E4E4 0% 0% no-repeat padding-box;

    .wy-rect-menu-arrow {
      display: none;
      position: relative;
      width: 8px;
      height: 8px;
      left: 8px;
      border: solid white;
      border-width: 0 1px 1px 0;
      transform: rotate(135deg);        
    }

    .wy-rect-menu-item {
      height: 59px;
    }

    .wy-rect-menu.active {
      .wy-rect-submenu {
        display: block;
      }
    }

    .wy-rect-menu-item.active {
      background-color: #FBFDFF;
      cursor: pointer;
      .wy-rect-menu-arrow {
        display: block;
        top: 26px;        
      }
    }

    .wy-rect-submenu-item.active {
      background-color: #FBFDFF;
      cursor: pointer;
      .wy-rect-menu-arrow {
        display: block;
        top: 21px;        
      }
    }

    .wy-rect-submenu {
      //display: none;   // Uncomment to enable menu item collapse
      .wy-rect-submenu-item {
        height: 51px;
      }
    }
  }

  .nav_menu-right.collapsed {
    .wy-rect-menu-arrow {
      left: 5px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
  }
}

.wy-contactReasons-page {
  #nav_left .nav_menu-left .wy-menu-item > div {
    padding: 0px 0px 0px 15px;
  }
}

.wy-brand.wy-product-ia, .wy-brand.wy-product-aq {
  .wy-menu-item {
    border-bottom: none !important;
    padding: 0px !important;
    > div {
      &:hover {
        background-color: #f4f6f8 !important;
      }
    }
  }
  .active {
    background-color: #ECEEF0 !important;
    &:hover {
      background-color: #f4f6f8 !important;
    }
    > div {
      background-color: #ECEEF0 !important;
    }
  }
  #nav_left .nav_menu-left {
    overflow-y: hidden !important;
  }
}

.wy-brand.wy-product-st {
  .wy-menu-item {
    border-bottom: none !important;
    padding: 0px !important;
    > div {
      &:hover {
        background-color: #f4f6f8 !important;
        .wy-menu-title {
          color: #444d54 !important;
        }
      }
    }
  }
  .active {
     background-color: #ECEEF0 !important;
    &:hover {
      background-color: #f4f6f8 !important;
    }
    > div {
      background-color: #ECEEF0 !important;
    }
  }
  #nav_left .nav_menu-left {
    overflow-y: hidden !important;
  }
}
</style>